import { render, staticRenderFns } from "./PaySlipPrint.vue?vue&type=template&id=1860f0fa&"
import script from "./PaySlipPrint.vue?vue&type=script&lang=js&"
export * from "./PaySlipPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports